import { Component, inject } from '@angular/core';
import { GenusService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GenusCreateDto,
  GenusDto,
  GenusExcelDownloadDto,
  GenusUpdateDto,
} from '../proxy/planning/dtos/genus';
import { GENUS_CONFIG, GENUS_FIELDS } from './genus.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genus',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GenusService, ConfirmationService],
  templateUrl: './genus.html',
  styleUrl: './genus.scss',
})
export class Genus extends BaseCrudComponent<
  GenusDto,
  GenusCreateDto,
  GenusUpdateDto,
  GenusExcelDownloadDto
> {
  service = inject(GenusService);
  config = GENUS_CONFIG;
  fields = GENUS_FIELDS;

  protected prepareUpdateDto(data: any, selected: GenusDto): GenusUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Genus';
  }
}
